// News Ticker Configuration
export const NEWS_TICKER_CONFIG = {
  // Default messages
  MESSAGES: {
    FIRST_COME_FIRST_SERVE: "⚡ Application forms are filling up fast! Please apply as soon as possible before we close applications. Don't miss this opportunity! 🚀📋",
    ZAKAT_FUNDING: "🕌 The scholarships and financial aid we provide are funded primarily through Zakat contributions. These funds are dedicated to supporting deserving students in their education. May Allah bless our donors and your journey ahead. 📚🤲✨💫",
    SCHOLARSHIP_AVAILABLE: "📚✨ New scholarship applications are now open! Apply today to secure your educational future. 🎯🌟",
    DEADLINE_REMINDER: "⏰🚨 Don't miss out! Application deadline is approaching. Submit your documents before the last date. 📄⚡",
    SUCCESS_STORY: "🎓🎉 Congratulations to our recent graduates who achieved success through your generous support! 🌟👏💪",
  },

  // Display settings
  DISPLAY_SETTINGS: {
    DEFAULT_SPEED: 60, // seconds for full scroll
    DEFAULT_BACKGROUND: "#28a745", // Bootstrap success green
    DEFAULT_TEXT_COLOR: "#ffffff",
    PAUSE_ON_HOVER: true,
    SHOW_ICON: true,
  },

  // Theme variants
  THEMES: {
    SUCCESS: {
      backgroundColor: "#28a745",
      textColor: "#ffffff"
    },
    INFO: {
      backgroundColor: "#17a2b8", 
      textColor: "#ffffff"
    },
    WARNING: {
      backgroundColor: "#ffc107",
      textColor: "#212529"
    },
    PRIMARY: {
      backgroundColor: "#007bff",
      textColor: "#ffffff"
    },
    ZAKAT_THEME: {
      backgroundColor: "#198754", // Islamic green
      textColor: "#ffffff"
    },
    FIRST_COME_FIRST_SERVE: {
      backgroundColor: "#17a2b8", 
      textColor: "#ffffff"
    },
  }
};

// Function to get current active message (can be extended to fetch from API)
export const getCurrentNewsMessage = () => {
  // For now, return the Zakat funding message
  // This can be extended to rotate messages or fetch from backend
  return NEWS_TICKER_CONFIG.MESSAGES.FIRST_COME_FIRST_SERVE;
};

// Function to get theme configuration
export const getNewsTickerTheme = (themeName = 'FIRST_COME_FIRST_SERVE') => {
  return NEWS_TICKER_CONFIG.THEMES[themeName] || NEWS_TICKER_CONFIG.THEMES.ZAKAT_THEME;
};
